import styled from "styled-components";
import { defaultTheme } from "storybook/themes/default";
import { tablet } from "styles/breakpoints";

const { colors } = defaultTheme;

export const Container = styled.div`
  width: 100%;
  display: flex;
  margin: 0 auto;
  min-width: 320px;
  max-width: 800px;
  flex-direction: column;
  padding: 27px 0 16px 0;

  button {
    width: 100%;
  }

  @media (max-width: ${tablet}px) {
    padding: 27px 16px 16px 16px;
  }
`;

export const PromptContainer = styled.div`
  margin-top: 8px;

  @media (min-width: ${tablet}px) {
    margin-top: 0;
  }

  && {
    p {
      color: ${colors.hematite};
    }
  }
`;

export const HeadingContainer = styled.div`
  margin-top: -2px;

  && {
    h1 {
      font-size: 20px;
      font-weight: 700;
      padding-bottom: 16px;
    }
  }
`;

export const SummaryContainer = styled.div`
  margin-top: 17px;

  @media (min-width: ${tablet}px) {
    margin-top: 32px;
  }
`;

export const NotificationContainer = styled.div`
  margin-top: 24px;
`;

export const GraphicContainer = styled.div`
  margin-top: 39px;
  display: flex;
  justify-content: center;

  @media (min-width: ${tablet}px) {
    margin-top: 170px;

    svg {
      transform: scale(1.75);
    }
  }
`;
